import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface SubmitButtonProps {
  canSubmit: boolean
  onClick?: () => void
  text: string
  width?: string
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  canSubmit,
  onClick,
  text,
  width,
}) => {
  return (
    <button
      className={css(
        styles.submitButton,
        !canSubmit && styles.submitButtonDisabled,
      )}
      style={width ? { width } : undefined}
      disabled={!canSubmit}
      onClick={onClick}
    >
      <span>{text}</span>
    </button>
  )
}

const styles = StyleSheet.create({
  submitButton: {
    backgroundColor: '#1C64F2',
    color: '#FFFFFF',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    height: '48px',
    width: '90%',
    ':hover': {
      backgroundColor: '#0056b3',
    },
  },
  submitButtonDisabled: {
    backgroundColor: '#cccccc',
    cursor: 'not-allowed',
    ':hover': {
      backgroundColor: '#cccccc',
    },
  },
})

export default SubmitButton
